// extracted by mini-css-extract-plugin
module.exports = {"email":"Nq","desktop":"Oq","mobile":"Pq","hidden":"Qq","visible":"Rq"};